import React, { useEffect } from 'react';
import './WhyChoose.css';
import AOS from 'aos';
import 'aos/dist/aos.css';

const reasons = [
  {
    title: "Data-Driven Strategy",
    description: "We don't guess. We use advanced analytics and market research to drive every decision and campaign roadmap.",
    icon: (
      <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <line x1="18" y1="20" x2="18" y2="10"></line>
        <line x1="12" y1="20" x2="12" y2="4"></line>
        <line x1="6" y1="20" x2="6" y2="14"></line>
      </svg>
    )
  },
  {
    title: "Expert Team",
    description: "Your brand is handled by certified specialists with years of experience in SEO, PPC, and Performance Marketing.",
    icon: (
      <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
        <circle cx="9" cy="7" r="4"></circle>
        <path d="M23 21v-2a4 4 0 0 0-3-3.87"></path>
        <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
      </svg>
    )
  },
  {
    title: "Full Transparency",
    description: "Real-time reporting and clear communication. You'll always know exactly where your investment is going and the results it's bringing.",
    icon: (
      <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path>
        <circle cx="12" cy="12" r="3"></circle>
      </svg>
    )
  },
  {
    title: "Customized Solutions",
    description: "Every business is unique. We build tailored marketing ecosystems that fit your specific goals, budget, and industry.",
    icon: (
      <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.12 2.12 0 0 1-3-3l6.91-6.91a6 6 0 0 1 7.94-7.94l-3.76 3.76z"></path>
      </svg>
    )
  }
];

const WhyChoose = () => {
  useEffect(() => {
    AOS.init({ duration: 1000, once: true });
  }, []);

  return (
    <section className="why-choose" id="why-choose">
      <div className="why-choose-container">
        <div className="why-choose-content">
          <div className="text-side" data-aos="fade-right">
            <span className="accent-text">Why Us?</span>
            <h2>Why Choose <span className="brand-highlight">cabptoid</span> for Your Growth?</h2>
            <p className="main-desc">
              We don't just provide services; we provide solutions. Our mission is to partner with brands and help them navigate the digital landscape with confidence.
            </p>
            
            <div className="stats-row">
              <div className="stat-item">
                <span className="stat-num">98%</span>
                <span className="stat-label">Client Retention</span>
              </div>
              <div className="stat-item">
                <span className="stat-num">500k+</span>
                <span className="stat-label">Leads Generated</span>
              </div>
            </div>
          </div>

          <div className="reasons-side">
            {reasons.map((reason, index) => (
              <div 
                className="reason-card" 
                key={index} 
                data-aos="fade-left" 
                data-aos-delay={index * 100}
              >
                <div className="reason-icon">{reason.icon}</div>
                <div className="reason-text">
                  <h3>{reason.title}</h3>
                  <p>{reason.description}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhyChoose;
